export const TASK_PRIORITY_CONFIG = Object.freeze({
    CRITICAL: { color: "#cf1322", label: "Critical", rank: 400, tone: "critical" },
    HIGH: { color: "#ff4d4f", label: "High", rank: 300, tone: "high" },
    MEDIUM: { color: "#faad14", label: "Medium", rank: 200, tone: "medium" },
    LOW: { color: "#52c41a", label: "Low", rank: 100, tone: "low" },
});

export const TASK_PRIORITY_VALUES = Object.freeze(Object.keys(TASK_PRIORITY_CONFIG));
export const DEFAULT_TASK_PRIORITY = "MEDIUM";

export function priorityRequirementLabel() {
    return TASK_PRIORITY_VALUES.join(", ").replace(/, ([^,]*)$/, ", or $1");
}
